import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';

export default function AuthGuard({ redirectTo = '/login' }: { redirectTo?: string }) {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    api.get('/me')
      .then(() => {
        if (location.pathname === '/kyc') return;
        api.get('/kyc/status').then(({ data: res }) => {
          const s = res.status;
          if (s !== 'approved' && s !== 'pending') {
            navigate('/kyc', { replace: true });
            return;
          }
          if (s === 'approved' && location.pathname !== '/team-compensation') {
            // api.get('/team-compensation/status').then(({ data }) => {
            //   if (!data?.data) {
            //     navigate('/team-compensation', { replace: true });
            //   }
            // }).catch(() => {});
          }
        }).catch(() => { });
      })
      .catch(() => {
        navigate(redirectTo, { replace: true });
      });
  }, [navigate, redirectTo, location.pathname]);
  return null;
}
